import { FC, useEffect } from 'react';
import CoreScroll from '@nrk/core-scroll';

import { SeasonSectionProps, useSeasonUrlState } from '../../hooks/seasonHooks';

import { EpisodeList } from './EpisodeList';
import { SeasonSelector } from './SeasonSelector';

import seriesStyles from './GenericSeriesSection.module.css';

export const GenericSeriesSection: FC<SeasonSectionProps> = ({ seriesData, onClickVariant }) => {
  const [selectedSeason, setSelectedSeason] = useSeasonUrlState(seriesData);

  useEffect(() => {
    // Scroll selected season-btn into view
    const scroller = document.querySelector(`.${seriesStyles.seasonList}`) as unknown as
      | (HTMLElement & CoreScroll['el'])
      | undefined;
    const seasonEl = scroller?.querySelector(`.${seriesStyles.selectedSeason}`);
    if (scroller && seasonEl instanceof HTMLElement) {
      scroller.scroll(seasonEl);
    }
  }, [selectedSeason]);

  return (
    <section>
      <SeasonSelector seriesData={seriesData} selectedSeason={selectedSeason} setSelectedSeason={setSelectedSeason} />
      <EpisodeList selectedSeason={selectedSeason} onClickVariant={onClickVariant} />
    </section>
  );
};
